/* eslint-disable */
// constants
import { MAX_ALLOWED_GROUPS } from './groupsTable.constants';

const getSelectedGroupIds = (selectedGroups) => selectedGroups.map((group) => group?.value);

export const getGroupIds = (groups = []) => groups.map((group) => group?.id);

export const isGroupSelected = (selectedGroupId, selectedGroups = []) => {
    const selectedGroupIds = getSelectedGroupIds(selectedGroups);
    return selectedGroupIds.includes(selectedGroupId);
}

export const isAdminGroup = (group) => {
    const groupName = group?.displayName
    const role = groupName?.split('-')?.[1]?.trim()?.toLowerCase();
    return role === 'admin'
}

export const shouldDisableGroup = ({
    group,
    isSuperAdminUser,
    selectedGroups = [],
    getSelectedGroupsCount }) => {
    const selectedGroupsCount = getSelectedGroupsCount(selectedGroups)
    if (selectedGroupsCount >= MAX_ALLOWED_GROUPS && !isGroupSelected(group?.id, selectedGroups)) {
        return true
    }
    if (isSuperAdminUser) {
        return false
    }
    return isAdminGroup(group)
}

export const shouldDisableSelectAll = ({
    groups = [],
    isSuperAdminUser,
    selectedGroups = [],
    getSelectedGroupsCount }) => {
    const groupsCount = groups.length
    const selectedGroupsCount = getSelectedGroupsCount(selectedGroups)
    const allGroupsChecked = areAllGroupsChecked(groups, selectedGroups);
    if (selectedGroupsCount >= MAX_ALLOWED_GROUPS ||
      (groupsCount > MAX_ALLOWED_GROUPS - selectedGroupsCount
        && !allGroupsChecked)) {
        return true;
    }
    if (isSuperAdminUser) {
        return false
    }
    return groups.some(isAdminGroup)
}

export const areAllGroupsChecked = (groups = [], selectedGroups = []) => {
    if (groups.length > 0) {
        return groups.every((group) => isGroupSelected(group.id, selectedGroups));
    }
    return false;
}

export const createGroup = (group = {}) => ({ value: group.id, display: group.displayName })

export const getSelectedGroupsWithOutSelectedGroupId = (selectedGroups, selectedGroupId) => {
    const filteredSelectedGroups = selectedGroups.filter(
        (selectedGroup) => selectedGroup?.value !== selectedGroupId
      );
      return filteredSelectedGroups;
}

export const sortGroups = ({ groups, sortBy, sortOrder }) => [...groups].sort((a, b) => {
    const isAsc = sortOrder === 'asc';
    return isAsc ? a[sortBy].localeCompare(b[sortBy]) : b[sortBy].localeCompare(a[sortBy]);
});
